<template>
  <div>
    <div class="select">
      <h4 class="title1">
        <span>&nbsp;&nbsp;查询条件</span>
      </h4>
      <div class="selectColor">
        <div class="row">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-row>
                <el-col :span="7">机构</el-col>
                <el-col :span="17">
                  <el-cascader placeholder="请输入" :options="options" filterable change-on-select v-model="manageCom"></el-cascader>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">
                  销售人员
                </el-col>
                <el-col :span="17"> <el-input placeholder="请输入销售人员" class="input" v-model="req.agentName"></el-input> </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">
                  险种代码
                </el-col>
                <el-col :span="17">
                  <el-select filterable multiple v-model="req.riskCodes" placeholder="请选择">
                    <!-- <el-option label="全部" :value="null">全部</el-option> -->
                    <el-option v-for="item in riskList" :key="item.value" :label="item.riskCode" :value="item.riskCode"></el-option>
                  </el-select>
                  <!-- <el-input placeholder="请输入险种代码" class="input" v-model="req.riskCode" maxlength="6"></el-input> -->
                  </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="7">
              <el-row>
                <el-col :span="7">险种名称</el-col>
                <el-col :span="17">
                  <el-input placeholder="请输入险种名称" class="input" v-model="req.riskName" >
                  </el-input>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">在售状态</el-col>
                <el-col :span="17">
                  <el-select v-model="saleState" placeholder="请选择">
                    <el-option label="全部" :value="null">全部</el-option>
                    <el-option label="是" value="1">是</el-option>
                    <el-option label="否" value="0">否</el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-col :span="7">业务编码</el-col>
                <el-col :span="17">
                 <el-input placeholder="请输入业务编码" class="input" v-model="agentCode" />
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="3">
              <div class="btnfilter"><el-button type="primary" @click="search()">筛选</el-button></div>
            </el-col>
          </el-row>
          <!-- <div class="btnfilter"> -->
          <!-- </div> -->
          <!-- <el-row>
            <el-col :span="2" :offset="22"><el-button type="primary" @click="search()">筛选</el-button></el-col>
          </el-row> -->
        </div>
      </div>
    </div>
    <div class="main">
      <h4 class="title1"><span>&nbsp;&nbsp;查询结果</span> <span class="btnP"><el-button class="right" type="primary" @click="exportResult">导出</el-button></span></h4>

      <el-table :data="list" style="width: 100%">
        <el-table-column type="index" label="编号" align="center"> </el-table-column>

        <el-table-column prop="t2Name" label="T2名称" align="center"> </el-table-column>
        <el-table-column prop="t2Code" label="T2代码" align="center"> </el-table-column>
        <el-table-column prop="t3Name" label="T3名称" align="center"> </el-table-column>
        <el-table-column prop="t3Code" label="T3代码" align="center"> </el-table-column>
        <el-table-column prop="t4Name" label="T4名称" align="center"> </el-table-column>
        <el-table-column prop="t4Code" label="T4代码" align="center"> </el-table-column>
        <el-table-column prop="authUserName" label="销售人员姓名" align="center"> </el-table-column>
        <el-table-column prop="authUserCode" width="120" label="业务编码" align="center"> </el-table-column>
        <el-table-column prop="riskCode" width="120" label="险种代码" align="center"> </el-table-column>
        <el-table-column prop="riskName" width='160' label="险种名称" align="center"> </el-table-column>

        <el-table-column :formatter="saleStateFilter" label="险种是否在售" align="center"> </el-table-column>
        <el-table-column prop="authStartDate" label="授权开始时间（全产品）" width="200" align="center"> </el-table-column>
        <el-table-column prop="authEndDate" label="授权结束时间" align="center" width="200"> </el-table-column>
      </el-table>
    </div>
    <Pagination :count="count" @currentChange="currentChange" :currentPage="req.currentPage"></Pagination>
  </div>
</template>

<script>
import api from '@/modules/api.js';
import url from '@/modules/url.js';
// import MinXin from '@/pages/exam/examNew/mixins/manageCom';
import Pagination from '@/pages/exam/examNew/components/pagination';
export default {
  // mixins: [MinXin],
  components: { Pagination },
  data() {
    return {
      riskList:[],
      riskCode: '',
      riskName: '',
      agentName:'',
      list: [],
      req1: {},
      req: {
        riskCodes: [],
        riskName: null,
        agentCode: 'ALL',
        currentPage: 1,
        pageSize: 10,
        saleState:null,
        agentName:null,
        manageCom:''
      },
      manageCom:[],
      manageCom1:[],
      options:[{}],
      dateStart: '',
      agentCode:'',
      status1List: [
        {
          value: '1',
          label: '在售'
        },
        {
          value: '0',
          label: '停售'
        }
      ],
      saleState: null,
      count: 0,
      result: [],
      loadUrl: '',
    };
  },
  methods: {
    currentChange(value) {
      this.req.currentPage = value;
      this.getAuthRisks()
    },
    saleStateFilter(row, column) {
      return row.saleState == 1 ? '在售' : '停售';
    },
    exportResult() {
      api.post(url.exportAuthRisks, this.req, res => {
        if (res.result.isSuccess === true) {
          console.log(res,'res')
          let saveLink = document.createElement('a');
          saveLink.href = res.data;
          saveLink.click();
        } else {
          if (res.result.errors.length > 0) {
            this.$message(res.result.errors[0].errorCode + res.result.errors[0].error);
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    initManageCom() {
      let that = this;
      api.post(url.initAllManageCom, {}, function(res) {
        that.options = JSON.stringify(res.data)
          .trim()
          .replace(/"children":\[\],/g, '');
        that.options = JSON.parse(that.options);
        that.manageCom = that.options[0].value;
        that.manageCom1 = that.options[0].value;
        // that.req.manageCom = that.options[0].children[0].value
        that.req.manageCom = that.options[0].value
        that.getAuthRisks()
      });
    },
    getAuthRisks() {
      // this.req.agentCode = 'ALL'
      let req = this.req;
      let req1 = { ...req };
      // this.req1.agentCode = 'ALL';
      if (this.status1 == '') {
        delete req.saleState;
      }
      console.log(req1,'req1')
      // const loading = this.$loading({
      //   lock: true,
      //   text: 'Loading',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      api.post(url.getAuthRisks, req1, res => {
        // loading.close();
        if (res.result.isSuccess === true) {
          this.list = res.data.list;
          this.count = res.data.count;
        } else {
          if (res.result.errors.length > 0) {
            this.$message(res.result.errors[0].errorCode + res.result.errors[0].error);
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    //获取类型险种列表
    initRiskTypes(){
      let that = this
      api.post(url.initRiskTypes, {}, function(res) {
        if (res.result.isSuccess) {
          that.riskList = res.data 
        } else {
          that.$message({

          });
        }
      });
    },
    search() {
      this.req.currentPage = 1
      this.req.saleState = this.saleState
      if(this.manageCom !== 'HO'){
        if(this.manageCom.length >1){
          if(this.manageCom.length === 2){
            this.req.manageCom  = this.manageCom[1]
          }else if(this.manageCom.length === 3){
            this.req.manageCom = this.manageCom[2]
          }else if(this.manageCom.length === 4){
            this.req.manageCom = this.manageCom[3]
          }
        }else {
          this.req.manageCom = this.manageCom[0]
        }
      }else{

      }
      this.getAuthRisks();
    }
  },
  watch: {
    loadUrl(newValue, oldValue) {
      console.log(newValue);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = newValue;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    agentCode(val){
      if(!this.agentCode){
        this.req.agentCode = 'ALL'
      }else{
        this.req.agentCode = this.agentCode
      }
    }
  },
  mounted() {
    this.initRiskTypes()
    this.initManageCom()
  }
};
</script>

<style scoped>
.title1 {
  background: #e0e0e0;
  height: 50px;
  line-height: 50px;
  margin: 0px 0px 0px 0px;
}
.selectColor {
  padding-bottom: 1px;
}
.selectColor >>> .el-cascader{
  width:100%;
}
.selectColor >>> .el-input__inner {
  padding:0 10px;
}
.selectColor >>> .el-select {
  width:100%;
}
.row {
  margin-top: 20px;
  padding-left: 20px;
  line-height: 50px;
}

.right {
  margin: 5px 22px 0 0;
  float: right;
}
.btnfilter{
  margin-right:22px;
  float: right;
} 
.maxWidth {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/examSaleQuery.vue